import React, { useContext, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles/ClassroomSidebar.module.css';
import { ClassroomContext } from '../../context/ClassroomContext';
import { classroomImages } from '../../utils/utils';
import {
    FaTachometerAlt, FaUsers, FaCog, FaBullhorn, FaScroll,
    FaFolderOpen, FaInfoCircle, FaChevronLeft, FaTasks
} from 'react-icons/fa';

const ClassroomSidebar = () => {
    const { classroom, clearCurrentClassroom } = useContext(ClassroomContext); 
    const location = useLocation();

    const randomImageRef = useRef(null);
    if (!randomImageRef.current) {
        const randomIndex = Math.floor(Math.random() * classroomImages.length);
        randomImageRef.current = classroomImages[randomIndex];
    }
    const fallbackImage = randomImageRef.current;

    const getActiveRoutes = (pathname) => {
        const segments = pathname.split('/');
        let mainRoute = segments[3];
        let subRoute = segments[4]; 

        if (['a', 'l', 'f', 'assignments'].includes(mainRoute)) {
            subRoute = mainRoute;
            mainRoute = 'd';
        }
        return { main: mainRoute, sub: subRoute };
    };

    const { main, sub } = getActiveRoutes(location.pathname);

    const mainLinks = [
        {
            label: 'Dashboard', path: 'd', icon: <FaTachometerAlt className={styles.icon} />,
            subLinks: [
                { label: 'Announcements', path: 'a', icon: <FaBullhorn style={{ marginRight: '6px' }} /> },
                { label: 'Logs', path: 'l', icon: <FaScroll style={{ marginRight: '6px' }} /> },
                // { label: 'Folders', path: 'f', icon: <FaFolderOpen style={{ marginRight: '6px' }} /> },
                { label: 'Assignments', path: 'assignments', icon: <FaTasks style={{ marginRight: '6px' }} /> },
            ],
            alwaysOpen: true
        },
        { label: 'About', path: 'i', icon: <FaInfoCircle className={styles.icon} /> },
        { label: 'People', path: 'p', icon: <FaUsers className={styles.icon} /> },
        { label: 'Settings', path: 'settings', icon: <FaCog className={styles.icon} /> }
    ];


    const handleBackClick = () => {
        clearCurrentClassroom();
    };

    return (
        <div className={styles.sidebarContainer}>
            <Link to="/my-classrooms" className={styles.backIcon} onClick={handleBackClick}>
                <FaChevronLeft />
            </Link>

            {/* NEW: Wrapper for classroom info */}
            <div className={styles.classroomInfoHeader}>
                {classroom ? (
                    <>
                        <div className={styles.classroomName}>{classroom.name}</div>
                        {classroom.owner && (
                            <div className={styles.classroomOwner}>
                                Owner: {classroom.owner.username}
                            </div>
                        )}
                        <img
                            src={(classroom.image && classroom.image.trim()) ? classroom.image : fallbackImage}
                            alt={classroom.name || 'Classroom'}
                            className={styles.classroomImage}
                        />
                    </>
                ) : (
                    
                    <div className={styles.classroomInfoPlaceholder}>
                        {/* tbd */}
                    </div>
                )}
            </div>

            <ul className={styles.navList}>
                {mainLinks.map(mainItem => {
                    const isMainActive = main === mainItem.path;
                    
                    return (
                        <li key={mainItem.path}>
                            <Link
                                to={`/my-classrooms/${classroom?._id}/${mainItem.path}`}
                                className={`${styles.navItem} ${isMainActive && (!mainItem.subLinks || !mainItem.subLinks.some(s => s.path === sub)) ? styles.active : ''}`}
                            >
                                {mainItem.icon}
                                {mainItem.label}
                            </Link>

                            {mainItem.alwaysOpen && mainItem.subLinks && (
                                <ul className={styles.subNavList}>
                                    {mainItem.subLinks.map(subItem => {
                                        
                                        const isSubActive = main === mainItem.path && sub === subItem.path;
                                        return (
                                            <li key={subItem.path}>
                                                <Link
                                                    to={`/my-classrooms/${classroom?._id}/${subItem.path}`}
                                                    className={`${styles.subNavItem} ${isSubActive ? styles.active : ''}`}
                                                >
                                                    {subItem.icon}
                                                    {subItem.label}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ClassroomSidebar;